import { render, staticRenderFns } from "./ProgramsListPopover.vue?vue&type=template&id=0b17e7a5&"
import script from "./ProgramsListPopover.vue?vue&type=script&lang=js&"
export * from "./ProgramsListPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports